export const GET_PARTNER_ID_QUERY = 'getPartnerId';
